module.exports = __webpack_public_path__ + "static/media/gallery-placeholder-image.e9425c78.webp";